<template>
  <hypto-popup title="Change Password">
    <template v-slot:body>
      <div class="merge-fields">
        <md-field :class="{'input-error': $v.currentPassword.$error || formErrors.current_password.length}">
          <label>Current password</label>
          <md-input v-model="currentPassword" @blur="$v.currentPassword.$touch()"
                    type="password" />
        </md-field>
        <h6 class="error-message" v-if="$v.currentPassword.$error">Please enter the current Password</h6>
        <error-info v-else :errorList="formErrors.current_password" />

        <md-field :class="{'input-error': $v.newPassword.$error || formErrors.password.length}">
          <label>New password</label>
          <md-input v-model="newPassword" @blur="$v.newPassword.$touch()"
                    type="password" />
        </md-field>
        <h6 class="error-message" v-if="$v.newPassword.$error">Please enter the new Password with atleast {{$v.newPassword.$params.minLength.min}} characters</h6>
        <error-info v-else :errorList="formErrors.password" />

        <md-field :class="{'input-error': $v.confirmPassword.$error || formErrors.password_confirmation.length}">
          <label>Confirm new password</label>
          <md-input v-model="confirmPassword" @keyup.enter="changePassword"
                    @blur="$v.confirmPassword.$touch()" type="password" />
        </md-field>
        <h6 class="error-message" v-if="$v.confirmPassword.$error && !$v.confirmPassword.required">Please enter the new Password again</h6>
        <h6 class="error-message" v-else-if="$v.confirmPassword.$error && !$v.confirmPassword.sameAs">The new Password does not match</h6>
        <error-info v-else :errorList="formErrors.password_confirmation" />
      </div>
    </template>

    <template v-slot:footer>
      <button class="primary-btn align-r" @click="changePassword" :disabled="isDisableButton">Change Password</button>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'
import ErrorInfo from '@/components/global/ErrorInfo'

import ApiServices from '@/services/api/userProfile'
import { required, sameAs, minLength } from 'vuelidate/lib/validators'
import { mapMutations } from 'vuex'
import { checkFormErrors } from '@/utils/helpers'
import formMixins from '@/mixins/formMixins'

export default {
  name: 'ChangePassword',
  components: { HyptoPopup, ErrorInfo },
  mixins: [formMixins],
  data () {
    return {
      currentPassword: null,
      newPassword: null,
      confirmPassword: null,
      formErrors: {
        current_password: [],
        password: [],
        password_confirmation: []
      }
    }
  },
  validations: {
    currentPassword: {required},
    newPassword: {
      required,
      minLength: minLength(8)
    },
    confirmPassword: {
      required,
      sameAs: sameAs('newPassword')
    }
  },
  watch: {
    currentPassword () {
      this.formErrors.current_password = []
    },
    newPassword () {
      this.formErrors.password = []
    },
    confirmPassword () {
      this.formErrors.password_confirmation = []
    }
  },
  methods: {
    checkFormErrors,
    ...mapMutations(['SET_USER_LOGGED_IN']),
    changePassword () {
      this.$v.$touch()
      if (!this.$v.$error && !this.checkFormErrors(this.formErrors)) {
        let params = {
          current_password: this.currentPassword,
          new_password: this.newPassword,
          confirm_new_password: this.confirmPassword
        }

        ApiServices.changePassword(params).then((response) => {
          this.successToastMsg(response.message, {isPublic: true})
          this.SET_USER_LOGGED_IN(false)
          this.enableButton()
        }).catch(error => {
          this.formErrors = {
            ...this.formErrors,
            ...error.body.reason
          }
        })
      }
    }
  }
}
</script>
